
import {getHistoryList} from '../api/getHistoryList';
import {setGetHistoryListAction} from '../action';

const setGetHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getHistoryList(params);

            if (data.status === 'success') {
                dispatch(setGetHistoryListAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetHistoryList
}